import type RipplingMigrationStatus from '@/data/migration/model';
import { ADMIN_IMPLEMENTATION, READY_FOR_ADMIN } from '@/data/migration/model';
import type { WiwState } from '@/store';

import { createSelector } from '@reduxjs/toolkit';

export const getMigrationStatus = (state: WiwState) => state.data.migration.migrationStatus;

export const getMigrationLoaded = (state: WiwState) => state.data.migration.loaded;

export const getIsMigrationReadyForAdmin = createSelector(
  [getMigrationStatus],
  (migration: RipplingMigrationStatus | null) => migration?.status === READY_FOR_ADMIN,
);
export const getIsMigrationAdminImplementation = createSelector(
  [getMigrationStatus],
  (migration: RipplingMigrationStatus | null) => migration?.status === ADMIN_IMPLEMENTATION,
);

export const getIsMigrationReady = createSelector(
  [getIsMigrationReadyForAdmin, getIsMigrationAdminImplementation],
  (readyForAdmin, readyForImpl) => readyForAdmin || readyForImpl,
);
